export enum TipoGrafico {
  PESOS,
  KWH,
}
